import React, { useEffect } from 'react';
import './Menu.css';

const Menu = () => {
  // Add class to identify tables with empty columns for mobile view
  useEffect(() => {
    const tables = document.querySelectorAll('.menu-table');
    tables.forEach(table => {
      // Check if this table has empty cells in the third column
      const emptyCells = table.querySelectorAll('td:nth-child(3):empty');
      if (emptyCells.length > 0) {
        table.classList.add('has-empty-column');
      }
    });
  }, []);

  return (
    <div className="menu-container">
      <h1 className="menu-title">Il Nostro Menu</h1>
      
      <section className="menu-section">
        <h2 className="section-title">PIZZE</h2>
        <p className="section-description">Disponibili tonde e in pala da 60 cm</p>
        
        <h3 className="subsection-title">PIZZE CLASSICHE</h3>
        <div className="menu-items">
          <table className="menu-table">
            <thead>
              <tr>
                <th>Pizza</th>
                <th>Ingredienti</th>
                <th>Tonda</th>
                <th>In pala</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="pizza-name">MARGHERITA</td>
                <td>pomodoro, mozzarella, olio Evo, basilico</td>
                <td>€4.50</td>
                <td>€10.00</td>
              </tr>
              <tr>
                <td className="pizza-name">NAPOLI</td>
                <td>pomodoro, mozzarella, acciughe, olive, capperi, olio Evo, basilico</td>
                <td>€6.50</td>
                <td>€13.50</td>
              </tr>
              <tr>
                <td className="pizza-name">REBECCA</td>
                <td>pomodoro, mozzarella, 'nduja, peperoni, gorgonzola, cipolla, olio Evo, basilico</td>
                <td>€8.00</td>
                <td>€16.50</td>
              </tr>
              <tr>
                <td className="pizza-name">CONTADINA</td>
                <td>pomodoro, mozzarella, melanzane, zucchine, peperoni, olio Evo, basilico</td>
                <td>€7.00</td>
                <td>€15.50</td>
              </tr>
              <tr>
                <td className="pizza-name">TONNO E CIPOLLA</td>
                <td>pomodoro, mozzarella, tonno, cipolla, olio Evo, basilico</td>
                <td>€6.50</td>
                <td>€13.50</td>
              </tr>
              <tr>
                <td className="pizza-name">CAPRICCIOSA</td>
                <td>pomodoro, mozzarella, cotto, funghi, carciofi, capperi, olive, olio Evo, basilico</td>
                <td>€7.00</td>
                <td>€15.50</td>
              </tr>
              <tr>
                <td className="pizza-name">FERROCINO</td>
                <td>pomodoro, mozzarella, crudo, rucola, grana, olio Evo, basilico</td>
                <td>€7.50</td>
                <td>€16.00</td>
              </tr>
              <tr>
                <td className="pizza-name">4 FORMAGGI</td>
                <td>pomodoro, mozzarella, gorgonzola, scamorza, grana, emmenthal, olio Evo, basilico</td>
                <td>€7.00</td>
                <td>€15.50</td>
              </tr>
              <tr>
                <td className="pizza-name">ITALIA</td>
                <td>pomodoro, mozzarella, grana, rucola, pomodorini, olio Evo</td>
                <td>€7.00</td>
                <td>€15.50</td>
              </tr>
              <tr>
                <td className="pizza-name">BOSCAIOLA</td>
                <td>pomodoro, mozzarella, salsiccia, funghi porcini, rucola, olio Evo</td>
                <td>€7.50</td>
                <td>€16.00</td>
              </tr>
              <tr>
                <td className="pizza-name">PATATINE</td>
                <td>pomodoro, mozzarella, patatine, olio Evo</td>
                <td>€5.50</td>
                <td>€13.00</td>
              </tr>
              <tr>
                <td className="pizza-name">VIENNESE</td>
                <td>pomodoro, mozzarella, wurstel, patatine, olio Evo</td>
                <td>€6.50</td>
                <td>€13.50</td>
              </tr>
              <tr>
                <td className="pizza-name">SAPORITA</td>
                <td>pomodoro, mozzarella, salame piccante, gorgonzola, rucola, olio Evo</td>
                <td>€7.00</td>
                <td>€15.50</td>
              </tr>
              <tr>
                <td className="pizza-name">FUME'</td>
                <td>pomodoro, mozzarella, speck, scamorza affumicata, olio Evo, basilico</td>
                <td>€6.50</td>
                <td>€13.50</td>
              </tr>
              <tr>
                <td className="pizza-name">SCATTARISCIATA</td>
                <td>pomodoro, provola affumicata, cotto arrosto, pomodori scattarisciati, Basilico, olio Evo</td>
                <td>€8.50</td>
                <td>€16.50</td>
              </tr>
              <tr>
                <td className="pizza-name">DIAVOLA</td>
                <td>pomodoro, mozzarella, salame piccante, basilico, olio Evo</td>
                <td>€5.50</td>
                <td>€13.00</td>
              </tr>
              <tr>
                <td className="pizza-name">PANCETTA E PORCINI</td>
                <td>pomodoro, mozzarella, pancetta, funghi porcini, olio Evo, basilico</td>
                <td>€7.50</td>
                <td>€16.00</td>
              </tr>
              <tr>
                <td className="pizza-name">BUFALOTTA</td>
                <td>pomodoro, mozzarella di bufala, olio Evo, basilico</td>
                <td>€7.50</td>
                <td>€16.00</td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <h3 className="subsection-title">PIZZE BIANCHE</h3>
        <div className="menu-items">
          <table className="menu-table">
            <thead>
              <tr>
                <th>Pizza</th>
                <th>Ingredienti</th>
                <th>Tonda</th>
                <th>In pala</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="pizza-name">PRIMAVERA</td>
                <td>mozzarella, pomodorini gialli e rossi semi dry, philadelphia, pesto al basilico</td>
                <td>€7.50</td>
                <td>€16.00</td>
              </tr>
              <tr>
                <td className="pizza-name">FRIARIELLI</td>
                <td>mozzarella, salsiccia, rape, olio Evo</td>
                <td>€7.50</td>
                <td>€16.00</td>
              </tr>
              <tr>
                <td className="pizza-name">BRESAOLA</td>
                <td>mozzarella, bresaola, rucola, grana, pomodorini, olio Evo</td>
                <td>€8.00</td>
                <td>€16.50</td>
              </tr>
              <tr>
                <td className="pizza-name">FIORDALISI</td>
                <td>panna, prosciutto cotto, panzerotti di patate, mozzarella, pepe, basilico, olio Evo</td>
                <td>€8.50</td>
                <td>€16.50</td>
              </tr>
              <tr>
                <td className="pizza-name">MARIA</td>
                <td>mozzarella, patate, funghi porcini, crema di tartufo, parmigiano, olio Evo</td>
                <td>€8.00</td>
                <td>€16.50</td>
              </tr>
              <tr>
                <td className="pizza-name">CRISTIANO</td>
                <td>mozzarella, burrata, mortadella, pesto di pistacchio, olio Evo</td>
                <td>€8.50</td>
                <td>€16.50</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      
      <section className="menu-section">
        <h2 className="section-title">PUCCE</h2>
        <div className="menu-items">
          <table className="menu-table">
            <thead>
              <tr>
                <th>Puccia</th>
                <th>Ingredienti</th>
                <th></th>
                <th>Prezzo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="item-name">SALENTINA</td>
                <td>tonno, capperi, svizzero, pomodoro, maionese, insalata</td>
                <td></td>
                <td>€5.90</td>
              </tr>
              <tr>
                <td className="item-name">DOLCE</td>
                <td>salame dolce, galbanone, patatine, maionese, pomodori secchi</td>
                <td></td>
                <td>€5.90</td>
              </tr>
              <tr>
                <td className="item-name">CARLOTTA</td>
                <td>pomodoro, rucola, insalata, crudo, crema formaggio, granella di noci</td>
                <td></td>
                <td>€5.90</td>
              </tr>
              <tr>
                <td className="item-name">PORCHETTA</td>
                <td>porchetta romana, formaggio, crema di tartufo, insalata, pomodori gialli</td>
                <td></td>
                <td>€5.90</td>
              </tr>
              <tr>
                <td className="item-name">DIAVOLOTTA</td>
                <td>salame piccante, crema formaggio, giardiniera, provola affumicata</td>
                <td></td>
                <td>€5.90</td>
              </tr>
              <tr>
                <td className="item-name">VEGETARIANA</td>
                <td>pomodoro, mozzarella, verdure, insalata, maio</td>
                <td></td>
                <td>€5.90</td>
              </tr>
              <tr>
                <td className="item-name">PORCELLINA</td>
                <td>pesto di pistacchio, burrata, mortadella</td>
                <td></td>
                <td>€5.90</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      
      <section className="menu-section">
        <h2 className="section-title">PANINI</h2>
        <div className="menu-items">
          <table className="menu-table">
            <thead>
              <tr>
                <th>Panino</th>
                <th>Ingredienti</th>
                <th></th>
                <th>Prezzo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="item-name">HAMBURGER</td>
                <td>hamburger, formaggio, patatine, ketchup, maionese, insalata, pomodori</td>
                <td></td>
                <td>€5.90</td>
              </tr>
              <tr>
                <td className="item-name">SALSICCIA DOLCE</td>
                <td>salsiccia dolce, formaggio, patatine, ketchup, maionese, insalata, pomodori</td>
                <td></td>
                <td>€5.90</td>
              </tr>
              <tr>
                <td className="item-name">SALSICCIA PICCANTE</td>
                <td>salsiccia piccante, formaggio, patatine, ketchup, maionese, insalata, pomodori</td>
                <td></td>
                <td>€5.90</td>
              </tr>
              <tr>
                <td className="item-name">COTOLETTA DI POLLO</td>
                <td>cotoletta di pollo, formaggio, patatine, ketchup, maionese, insalata, pomodori</td>
                <td></td>
                <td>€5.90</td>
              </tr>
              <tr>
                <td className="item-name">PORCHETTA ROMANA</td>
                <td>porchetta romana, formaggio, patatine, ketchup, maionese, insalata, pomodori</td>
                <td></td>
                <td>€5.90</td>
              </tr>
              <tr>
                <td className="item-name">WURSTEL</td>
                <td>wurstel, formaggio, patatine, ketchup, maionese</td>
                <td></td>
                <td>€4.90</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      
      <section className="menu-section">
        <h2 className="section-title">FRITTINI</h2>
        <div className="menu-items">
          <table className="menu-table">
            <thead>
              <tr>
                <th>Prodotto</th>
                <th>Descrizione</th>
                <th></th>
                <th>Prezzo</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="item-name">PATATINE (PICCOLA)</td>
                <td><span className="note">PATATINE LARGHE + €0.50</span></td>
                <td></td>
                <td>€2.00</td>
              </tr>
              <tr>
                <td className="item-name">PATATINE (MEDIA)</td>
                <td><span className="note">PATATINE LARGHE + €0.50</span></td>
                <td></td>
                <td>€3.00</td>
              </tr>
              <tr>
                <td className="item-name">PATATINE (GRANDE)</td>
                <td><span className="note">PATATINE LARGHE + €0.50</span></td>
                <td></td>
                <td>€4.00</td>
              </tr>
              <tr>
                <td className="item-name">PANZEROTTI DI PATATE</td>
                <td></td>
                <td></td>
                <td>€13.90</td>
              </tr>
              <tr>
                <td className="item-name">PITTULE</td>
                <td></td>
                <td></td>
                <td>€10.90</td>
              </tr>
              <tr>
                <td className="item-name">POLPETTE DI CARNE</td>
                <td></td>
                <td></td>
                <td>€18.90</td>
              </tr>
              <tr>
                <td className="item-name">NUGGETS DI POLLO</td>
                <td></td>
                <td></td>
                <td>€14.90</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      
      <section className="menu-notes">
        <h3>Note:</h3>
        <ul>
          <li>Ingredienti aggiuntivi da €0.50 a €2.00 a seconda degli ingredienti</li>
          <li>Tutte le pizze possono essere preparate con mozzarella di bufala (+€1.50)</li>
          <li>Si prega di informare il personale riguardo allergie o intolleranze</li>
        </ul>
      </section>
    </div>
  );
};

export default Menu;
